import { render, staticRenderFns } from "./TrainingRecords.vue?vue&type=template&id=0309237c"
import script from "./TrainingRecords.js?vue&type=script&lang=js&external"
export * from "./TrainingRecords.js?vue&type=script&lang=js&external"
import style0 from "./TrainingRecords.vue?vue&type=style&index=0&id=0309237c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0309237c')) {
      api.createRecord('0309237c', component.options)
    } else {
      api.reload('0309237c', component.options)
    }
    module.hot.accept("./TrainingRecords.vue?vue&type=template&id=0309237c", function () {
      api.rerender('0309237c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/training-records/TrainingRecords.vue"
export default component.exports